export default "<p>auth-header works!</p>\n"